import { CartTotalDetails } from "./CartTotalDetails";

export default CartTotalDetails;